import React, { useCallback } from 'react';
import { SearchResultsLayout } from '../Common/SearchResultsLayout/SearchResultsLayout';
import { useDispatch } from 'react-redux';
import { shopifyDecisionTreeSelectOrder } from '../../../../../../../actions/tools/ShopifyActions';

const SearchResultsShopify = () => {
  const dispatch = useDispatch();

  const handleSelectOrder = useCallback(
    (order) => {
      return dispatch(shopifyDecisionTreeSelectOrder(order));
    },
    [dispatch]
  );

  return <SearchResultsLayout onSelectOrder={handleSelectOrder} />;
};

export default SearchResultsShopify;
